import { render, staticRenderFns } from "./FormItemNumber.vue?vue&type=template&id=b1a5b9fc"
import script from "./FormItemNumber.vue?vue&type=script&lang=js"
export * from "./FormItemNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports